import store from '@/store/index';
import Configurator from '../components/Configurator';

export default [
  {
    name:        'configurator',
    path:        '/configurator/:id',
    component:   Configurator,
    props:       true,
    beforeEnter: (to, from, next) => {
      if (store.getters.orderItemId === null) {
        next('/menu');

        return;
      }

      next();
    },
  },
];



// WEBPACK FOOTER //
// ./src/apps/configurator/router/index.js